/*
 * Terms & conditions checkbox for the cart (drawer and cart page).
 * - The Checkout button stays clickable. If the box is not ticked, the click is
 *   blocked and a clear message asks the customer to tick it.
 * - Express buttons (Shop Pay, PayPal, Google Pay) are left untouched (owner's choice).
 * - The Checkout button is rendered "disabled" in Liquid, so if this script
 *   ever fails to load nobody can skip the terms.
 */
(function () {
  if (customElements.get('terms-checkbox')) return;

  var ERROR_TEXT = 'Please tick the box to agree to the terms and conditions before checking out.';

  function injectStyles() {
    if (document.getElementById('terms-checkbox-styles')) return;
    var style = document.createElement('style');
    style.id = 'terms-checkbox-styles';
    style.textContent = [
      '.agree-to-terms{border-radius:6px;transition:outline-color .2s ease}',
      '.agree-to-terms.is-error{outline:2px solid #b3261e;outline-offset:4px}',
      '.agree-to-terms.is-error label{color:#b3261e}',
      '.agree-to-terms__error{margin:8px 0 0;color:#b3261e;font-weight:500;line-height:1.35;text-wrap:pretty}',
      '.agree-to-terms__error[hidden]{display:none}',
      '.agree-to-terms.is-shaking{animation:terms-shake .4s cubic-bezier(.36,.07,.19,.97) both}',
      '@keyframes terms-shake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}30%,50%,70%{transform:translateX(-4px)}40%,60%{transform:translateX(4px)}}',
      '@media (prefers-reduced-motion:reduce){.agree-to-terms.is-shaking{animation:none}}'
    ].join('');
    document.head.appendChild(style);
  }

  class TermsAndConditionsToggle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      injectStyles();
      this.setup();
      if (!this.checkoutButton) requestAnimationFrame(this.setup.bind(this));
    }

    setup() {
      if (this._bound) return;
      this.checkbox = this.querySelector('#AgreeToTos') || this.querySelector('input[type="checkbox"]');
      this.wrapper = this.querySelector('.agree-to-terms') || this;
      this.scope = this.closest('#AjaxCartSubtotal') || this.parentElement || document;
      this.checkoutButton = this.scope.querySelector('#CheckOut');
      if (!this.checkbox || !this.checkoutButton) return;
      this._bound = true;

      // Message shown when the customer tries to check out without ticking.
      this.message = document.createElement('p');
      this.message.id = 'AgreeToTosError-' + Math.random().toString(36).slice(2, 8);
      this.message.className = 'agree-to-terms__error text-size--small';
      this.message.setAttribute('role', 'alert');
      this.message.textContent = this.dataset.errorText || ERROR_TEXT;
      this.message.hidden = true;
      this.appendChild(this.message);
      this.checkbox.setAttribute('aria-describedby', this.message.id);

      // Checkout button: always clickable, blocked only if the box is unticked.
      this.checkoutButton.disabled = false;
      this.checkoutButton.removeAttribute('disabled');
      this.checkoutButton.addEventListener('click', (event) => {
        if (this.checkbox.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showError();
      }, true);

      this.checkbox.addEventListener('change', () => this.update());
      this.update();
    }

    update() {
      var ok = this.checkbox.checked;
      if (ok) this.clearError();
    }

    showError() {
      this.message.hidden = false;
      this.checkbox.setAttribute('aria-invalid', 'true');
      this.wrapper.classList.add('is-error');
      this.wrapper.classList.remove('is-shaking');
      void this.wrapper.offsetWidth; // restart the animation on repeated clicks
      this.wrapper.classList.add('is-shaking');
      this.wrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
      try { this.checkbox.focus({ preventScroll: true }); } catch (e) { this.checkbox.focus(); }
    }

    clearError() {
      this.message.hidden = true;
      this.checkbox.removeAttribute('aria-invalid');
      this.wrapper.classList.remove('is-error', 'is-shaking');
    }
  }

  customElements.define('terms-checkbox', TermsAndConditionsToggle);
})();
